<template>
  <div>
    <div class="input-group">
      <div class="input-group-prepend">
        <label class="input-group-text" for="inputGroupSelect01">{{
          tx(this.attributes.label)
        }}</label>
        <helpWidget
          v-if="this.attributes.help_img || this.attributes.help"
          class="md-layout-item"
          :help="help_key"
          :help_img="`${this.IREALCONFIG.static_ressources}/${this.attributes.help_img}.png`"
          :help_style="this.attributes.help_style"
        ></helpWidget>
      </div>
      <md-field>
        <md-select
          v-model="selected"
          class="custom-select"
          id="inputGroupSelect01"
        >
          <md-option disabled value="">Please select one</md-option>
          <md-option :value="o" v-for="o in options" :key="o">{{
            tx(`${model}_${o}`)
          }}</md-option>
        </md-select>
      </md-field>
    </div>
    <component
      v-for="element in config.elements"
      :key="element.id"
      :is="getComponentName(element)"
      :config="element"
      style="margin-bottom: 5%"
    ></component>
    <!--
    <md-button
      v-if="EventProgress == 0 || EventProgress == 100"
      class="md-info"
      @click="export_data_file(selected)"
    >
      <md-icon>cloud_download</md-icon> {{ $t("export") }}
    </md-button>
    <md-button v-else class="md-info" @click="export_data_file('')">
      <md-icon>cloud_download</md-icon> {{ $t("export_in_progress") }}
    </md-button>
    --->
    <md-button
      v-if="EventProgress == 0 || EventProgress == 100"
      class="md-info"
      @click="export_data_file('')"
    >
      <md-icon>cloud_download</md-icon> {{ $t("export_all") }}
    </md-button>
    <md-button v-else class="md-info" @click="export_data_file('')">
      <md-icon>cloud_download</md-icon> {{ $t("export_in_progress") }}
    </md-button>
    <div v-if="EventProgress > 0 && EventProgress < 100" class="progress mt-3">
      <div
        :class="`progress-bar progress-bar-striped`"
        :style="`width:${EventProgress}%`"
        role="progressbar"
        :aria-valuenow="EventProgress"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </div>
</template>

<script>
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import Bus from "../services/bus.js";

export default {
  name: "select-output-component",
  mixins: [inputComponentMixin],
  data() {
    return {
      selected: null,
      EventProgress: "0",
    };
  },
  async mounted() {
    this.selected = this.attributes.default;
  },
  created() {
    Bus.$on("event progress", (msg) => {
      this.EventProgress = msg;
    });
  },
  watch: {
    selected: function (value) {
      this.isSelected = [];
      for (var o in this.options) {
        this.isSelected.push(this.tx(`${this.model}_${this.options[o]}`));
      }
      var index = this.isSelected.indexOf(value);
      index !== -1 ? this.isSelected.splice(index, 1) : "";
      this.$store.commit("setSelected", { param: this.model, value, mode:"slider" });
    },
  },
  computed: {
    options() {
      if (this.attributes.options === undefined) return [];
      else return this.attributes.options.split("|");
    },
  },
};
</script>
<style scoped>
/* ce style est calé sur le style de 'container-fluid' dans lequel est intégré un collapsibleWidget*/
.input-group {
  padding-left: 15px;
  padding-right: 15px;
}
</style>
